module.exports = __webpack_public_path__ + "static/media/436068996_489779330235900_2994708379358124798_n.79ad1a19.jpg";